module.exports = __webpack_public_path__ + "static/media/kizad.91f12714.png";